document.documentElement.classList.remove('no-js');

const qs = (selector, context = document) => context.querySelector(selector);
const qsa = (selector, context = document) => [...context.querySelectorAll(selector)];
const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

function toast(message) {
  const el = qs('[data-toast]');
  if (!el) return;
  el.textContent = message;
  el.classList.add('is-visible');
  clearTimeout(window.pcToast);
  window.pcToast = window.setTimeout(() => el.classList.remove('is-visible'), 2600);
}

function money(cents) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(cents || 0) / 100);
}

function toEmbedUrl(url) {
  if (!url) return '';
  try {
    if (url.includes('youtu.be/')) return `https://www.youtube.com/embed/${url.split('youtu.be/')[1].split(/[?&]/)[0]}`;
    if (url.includes('youtube.com/watch')) return `https://www.youtube.com/embed/${new URL(url).searchParams.get('v')}`;
    if (url.includes('youtube.com/embed/')) return url;
    if (url.includes('vimeo.com/')) return `https://player.vimeo.com/video/${url.split('vimeo.com/')[1].split(/[?&]/)[0]}`;
  } catch (error) {
    return '';
  }
  return url;
}

qsa('[data-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
  const menu = qs('[data-mobile-menu]');
  if (!menu) return;
  const opening = menu.hasAttribute('hidden');
  if (opening) {
    menu.removeAttribute('hidden');
    document.body.classList.add('menu-open');
  } else {
    menu.setAttribute('hidden', '');
    document.body.classList.remove('menu-open');
  }
  qsa('[data-menu-toggle]').forEach((item) => item.setAttribute('aria-expanded', opening ? 'true' : 'false'));
}));

const announcement = qs('[data-announcement]');
if (announcement) {
  const items = qsa('[data-announcement-item]', announcement);
  let index = 0;
  const speed = Number(announcement.dataset.speed) || 5000;
  if (items.length > 1) window.setInterval(() => {
    items[index].classList.remove('is-active');
    index = (index + 1) % items.length;
    items[index].classList.add('is-active');
  }, speed);
}

const revealElements = qsa('[data-reveal], [data-blur-reveal]');
if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
  revealElements.forEach((element) => revealObserver.observe(element));
} else {
  revealElements.forEach((element) => element.classList.add('is-visible'));
}

qsa('[data-copy-coupon]').forEach((button) => button.addEventListener('click', async () => {
  try {
    await navigator.clipboard.writeText(button.dataset.copyCoupon);
    toast(`Cupom copiado: ${button.dataset.copyCoupon}`);
  } catch (error) {
    toast(`Cupom: ${button.dataset.copyCoupon}`);
  }
}));

qsa('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
  if (!window.fetch) return;
  event.preventDefault();
  const button = qs('[type="submit"]', form);
  if (button) button.disabled = true;
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error((await response.json()).description || 'Não foi possível adicionar');
    const cart = await fetch('/cart.js').then((result) => result.json());
    qsa('[data-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
    toast('Produto adicionado ao carrinho.');
  } catch (error) {
    toast(error.message);
  } finally {
    if (button) button.disabled = false;
  }
}));

function initializeGallery(gallery) {
  const items = qsa('[data-media-index]', gallery);
  if (items.length < 1) return;
  const stage = qs('[data-gallery-stage]', gallery);
  const counter = qs('[data-gallery-current]', gallery);
  let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));

  const activate = (nextIndex) => {
    const index = (nextIndex + items.length) % items.length;
    items.forEach((item, itemIndex) => {
      const active = itemIndex === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (!active) qsa('video', item).forEach((video) => video.pause());
    });
    qsa('[data-gallery-thumb], [data-gallery-dot]', gallery).forEach((control) => {
      const controlIndex = Number(control.dataset.galleryThumb ?? control.dataset.galleryDot);
      control.classList.toggle('is-active', controlIndex === index);
    });
    activeIndex = index;
    if (counter) counter.textContent = String(index + 1);
  };

  gallery._activateMedia = activate;
  qsa('[data-gallery-thumb]', gallery).forEach((button) => button.addEventListener('click', () => activate(Number(button.dataset.galleryThumb))));
  qsa('[data-gallery-dot]', gallery).forEach((button) => button.addEventListener('click', () => activate(Number(button.dataset.galleryDot))));
  qs('[data-gallery-prev]', gallery)?.addEventListener('click', () => activate(activeIndex - 1));
  qs('[data-gallery-next]', gallery)?.addEventListener('click', () => activate(activeIndex + 1));

  if (stage && items.length > 1) {
    stage.tabIndex = 0;
    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') activate(activeIndex - 1);
      if (event.key === 'ArrowRight') activate(activeIndex + 1);
    });
    let startX = 0;
    let startY = 0;
    stage.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      startY = event.clientY;
    }, { passive: true });
    stage.addEventListener('pointerup', (event) => {
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      if (Math.abs(deltaX) < 46 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      activate(activeIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true });
  }
}
qsa('[data-product-gallery]').forEach(initializeGallery);

qsa('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => {
  const input = qs('input[type="number"]', button.parentElement);
  if (input) input.value = Math.max(1, Number(input.value || 1) - 1);
}));
qsa('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => {
  const input = qs('input[type="number"]', button.parentElement);
  if (input) input.value = Number(input.value || 1) + 1;
}));

qsa('[data-product-root]').forEach((root) => {
  let product;
  let inventory = {};
  try { product = JSON.parse(root.dataset.productJson); } catch (error) { return; }
  try { inventory = JSON.parse(qs('[data-product-inventory-json]', root)?.textContent || '{}'); } catch (error) { inventory = {}; }

  root._inventory = inventory;
  const options = qsa('[data-option-position]', root);
  const hidden = qs('[data-variant-id]', root);
  const addButton = qs('[data-add-button]', root);
  const stickyPrice = qs('[data-sticky-price]', root);
  const priceBox = qs('[data-product-price]', root);
  const mainStockStatus = qs('[data-main-stock-status]', root);
  const gallery = qs('[data-product-gallery]', root);
  const pixDiscount = clamp(Number(root.dataset.pixDiscount || 0), 0, 100);

  function updateVariant() {
    const selected = [];
    for (let position = 1; position <= 3; position += 1) {
      const checked = qs(`[data-option-position="${position}"]:checked`, root);
      if (checked) selected.push(checked.value);
    }
    const variant = product.variants.find((candidate) => candidate.options.every((option, index) => option === selected[index])) || product.variants[0];
    if (!variant) return;

    root.dataset.currentVariantId = String(variant.id);
    if (hidden) hidden.value = variant.id;
    if (addButton) {
      addButton.disabled = !variant.available;
      const label = qs('span', addButton);
      if (label) label.textContent = variant.available ? 'COMPRAR AGORA' : 'INDISPONÍVEL';
    }
    if (stickyPrice) stickyPrice.textContent = money(variant.price);
    if (mainStockStatus) mainStockStatus.textContent = '';
    if (priceBox) {
      const compare = variant.compare_at_price && variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : '';
      const pixPrice = Math.round(variant.price * (1 - pixDiscount / 100));
      const pix = pixDiscount > 0 ? `<span class="pc-price__pix">${money(pixPrice)} no Pix (${pixDiscount}% OFF)</span>` : '';
      priceBox.innerHTML = `<div class="pc-price">${compare}<strong>${money(variant.price)}</strong>${pix}</div>`;
    }
    if (variant.featured_media && gallery?._activateMedia) {
      const media = qs(`[data-media-id="${variant.featured_media.id}"]`, gallery);
      if (media) gallery._activateMedia(Number(media.dataset.mediaIndex));
    }
  }

  options.forEach((option) => option.addEventListener('change', updateVariant));
  updateVariant();

	  const buyBar = qs('[data-mobile-buy-bar]', root);
	  const form = qs('.product-form', root);
	  if (buyBar && form && 'IntersectionObserver' in window) {
	    new IntersectionObserver(([entry]) => {
	      buyBar.classList.toggle('is-visible', entry.boundingClientRect.bottom < 0);
	    }, { threshold: 0 }).observe(form);
	  }
  qs('[data-scroll-buy]', root)?.addEventListener('click', () => qs('.product-form__submit', root)?.scrollIntoView({ behavior: 'smooth', block: 'center' }));
});

qsa('[data-cep-button]').forEach((button) => button.addEventListener('click', () => {
  const box = button.closest('[data-cep-box]');
  const input = qs('[data-cep-input]', box);
  const output = qs('[data-cep-result]', box);
  if (!input || !output) return;
  const cep = input.value.replace(/\D/g, '');
  if (cep.length !== 8) {
    output.hidden = false;
    output.textContent = 'Digite um CEP válido com 8 números.';
    return;
  }
  input.value = cep.replace(/(\d{5})(\d{3})/, '$1-$2');
  output.hidden = false;
  output.textContent = box.dataset.deliveryText || 'Prazo confirmado no checkout.';
}));

qsa('[data-video-play]').forEach((button) => button.addEventListener('click', () => {
  const embed = toEmbedUrl(button.dataset.videoUrl);
  if (!embed) {
    toast('Adicione o link do vídeo no editor do tema.');
    return;
  }
  button.innerHTML = `<iframe src="${embed}${embed.includes('?') ? '&' : '?'}autoplay=1" title="Vídeo do produto" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
}));

function updateShippingJourneys() {
  qsa('[data-shipping-journey]').forEach((section) => {
    const route = qs('.shipping-route', section);
    const rail = qs('.shipping-route__rail', section);
    const truck = qs('.shipping-route__truck', section);
    if (!route || !rail || !truck) return;
    const rect = route.getBoundingClientRect();
    const start = window.innerHeight * 0.86;
    const distance = Math.max(window.innerHeight * 0.58, 320);
    const progress = clamp((start - rect.top) / distance);
    const railWidth = rail.getBoundingClientRect().width;
    const travel = Math.max(0, railWidth - truck.getBoundingClientRect().width);
    section.style.setProperty('--route-width', `${progress * 100}%`);
    section.style.setProperty('--route-x', `${progress * travel}px`);
    section.classList.toggle('is-arrived', progress > 0.86);
  });
}
let shippingTicking = false;
function requestShippingUpdate() {
  if (shippingTicking) return;
  shippingTicking = true;
  window.requestAnimationFrame(() => {
    updateShippingJourneys();
    shippingTicking = false;
  });
}
window.addEventListener('scroll', requestShippingUpdate, { passive: true });
window.addEventListener('resize', requestShippingUpdate);
requestShippingUpdate();

const whatsappAssist = qs('[data-whatsapp-assist]');
function updateWhatsappAssist() {
  if (!whatsappAssist) return;
  const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
  whatsappAssist.classList.toggle('is-visible', window.scrollY / scrollable >= 0.5);
}
window.addEventListener('scroll', updateWhatsappAssist, { passive: true });
window.addEventListener('resize', updateWhatsappAssist);
updateWhatsappAssist();

const recommendations = qs('[data-product-recommendations]');
if (recommendations && !recommendations.innerHTML.trim()) {
  fetch(recommendations.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const documentFragment = new DOMParser().parseFromString(text, 'text/html');
      const incoming = qs('[data-product-recommendations]', documentFragment);
      if (incoming) recommendations.innerHTML = incoming.innerHTML;
    })
    .catch(() => {});
}

qsa('[data-apply-discount]').forEach((button) => button.addEventListener('click', () => {
  const input = qs('[data-cart-coupon]', button.closest('.cart-summary'));
  const code = (input?.value || '').trim();
  if (!code) {
    toast('Digite um cupom.');
    return;
  }
  window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
}));

qsa('[data-tracking-form]').forEach((form) => form.addEventListener('submit', (event) => {
  event.preventDefault();
  const code = qs('input', form)?.value.trim();
  if (!code) return;
  window.open(`${form.dataset.baseUrl}${encodeURIComponent(code)}`, '_blank', 'noopener');
}));
